import React, { ReactElement } from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { BodyVariant } from '../Text';
interface BaseProps {
  /** Content to be labeled */
  children?: ReactElement;
  /** Pass through classname to allow styles overrides */
  className?: string;
  /** Pass through style to allow styles overrides */
  style?: React.CSSProperties;
  /** Content of the label */
  value: ReactElement | string;
  /** Should align label to the left */
  isHorizontalAligned?: boolean;
  /** The body variant of the component */
  variant?: BodyVariant;
  /** Should render isRequired icon * */
  isRequired?: boolean;
}
interface PropsWithChildren extends BaseProps {
  /** Content to be labeled */
  children: ReactElement;
  /** Id of an explicitly associated element. Can be used to disassociate the label from its child by setting it to an empty string. */
  forId?: string;
}
interface PropsWithoutChildren extends BaseProps {
  /** Content to be labeled */
  children?: ReactElement;
  /** Id of an explicitly associated element. You have to provide this id if you are not wrapping element that you want to label. */
  forId: string;
}
type Props = PropsWithChildren | PropsWithoutChildren;
export const RequiredMark = /*#__PURE__*/styled('span')({
  name: "RequiredMark",
  class: "r1nl2fc3",
  propsAsIs: false
});
const typographyStyles: Record<BodyVariant, string> = {
  bodyXS: "bp0z1c7",
  bodyS: "b9t8vc8",
  bodyM: "b1n4hrv",
  bodyL: "b1izf8o6"
};
const LabelWrapper = /*#__PURE__*/styled('label')({
  name: "LabelWrapper",
  class: "l13hjtkz",
  propsAsIs: false
});
export const Label = ({
  children,
  forId,
  value,
  isHorizontalAligned = false,
  variant = 'bodyM',
  isRequired = false,
  className,
  style
}: Props) => <LabelWrapper htmlFor={forId} className={cx(className, isHorizontalAligned && '--horizontal', typographyStyles[variant])} style={style}>
    <span>
      {value}
      {isRequired && <RequiredMark>*</RequiredMark>}
    </span>
    {children}
  </LabelWrapper>;

require("./Label.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./Label.tsx");